import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { startAlerta } from "../../../actions/ui/alertas";
import { startSpinner, finishSpinner } from "../../../actions/ui/spinner";
import BuscadorPractica from "../../turnos/coseguros/BuscadorPractica";
import { addPractica } from "../../../actions/autorizaciones/Autorizaciones";
import { Button, Grid } from "@material-ui/core";
import { AUTORIZACIONES_PRACTICAS_ESTADOS, TIPOS_AUTORIZACIONES } from "../../../utils/constants";

export const AutorizacionesAddPractica = ({ postAgregar, idTipoSolicitud,
  permiteAgregarPracticaPeriodo }) => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada, practicas = {} } =
    useSelector((state) => state.autorizaciones);
  const { presupuestoSeleccionado = {} } = useSelector((state) => state.autorizaciones);

  const [codigoPractica, setCodigoPractica] = useState(null);
  const codigoPracticaRef = useRef(null);

  const onClickAgregarHandler = () => {
    
    if (codigoPractica) {
      if (!idTipoSolicitud || idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRESUPUESTOS) {
        const buscarDatosDenunciaInternacion = (solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION ||
          solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA || solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.OXIGENO)
          &&
          practicas.length > 0;

        const practicaAuth = {
          idSolicitud: solicitudSeleccionada?.idSolicitud,
          cant: 1,
          idCodNom: codigoPractica.idCodNom,
          recuperoSur: codigoPractica.recuperoSur ?? false,
          practica: {
            codNom: codigoPractica.codNom,
            desNom: codigoPractica.desNom,
            nivelAutorizacion: codigoPractica.nivelautorizacion
          },
          periodos: [],
          materiales: [],
          conMateriales: false,
          idEfectorFacturacion: buscarDatosDenunciaInternacion ? practicas[0].idEfectorFacturacion : null,
          idCartillaPrestador: buscarDatosDenunciaInternacion ? practicas[0].idCartillaPrestador : null,
          idPrestador: null,
          idPrescriptor: null,
          idTipoSolicitud: solicitudSeleccionada?.idTipoSolicitud,
          idEstadoPractica: ((idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA || idTipoSolicitud === TIPOS_AUTORIZACIONES.OXIGENO) && permiteAgregarPracticaPeriodo)
            ? AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION
            : AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE,
        };
        dispatch(startSpinner());
        dispatch(addPractica(practicaAuth));
      } else {
        const practicaPresup = {
          idPresupuesto: presupuestoSeleccionado.idPresupuesto,
          cant: 1,
          idCodNom: codigoPractica.idCodNom,
          recuperoSur: codigoPractica.recuperoSur,
          practica: {
            codNom: codigoPractica.codNom,
            desNom: codigoPractica.desNom,
            nivelAutorizacion: codigoPractica.nivelautorizacion
          },
          idTipoSolicitud: presupuestoSeleccionado.idTipoSolicitud,
          idEstadoPractica: AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE,
        };
        dispatch(startSpinner());
        dispatch(addPractica(practicaPresup));
      }
      dispatch(finishSpinner());
      codigoPracticaRef.current.resetValues();
      setCodigoPractica(null);
      if (!!postAgregar) postAgregar();
    } else {
      dispatch(startAlerta("Ingrese una practica", "warning", "Atencion"));
    }
  };

  return (
    <React.Fragment>
      <Grid
        container
        spacing={2}
        style={{ width: "60%", margin: "auto", marginTop: "1rem" }}
      >
        <Grid item xs={12}>
          <BuscadorPractica
            ref={codigoPracticaRef}
            cod={codigoPractica}
            label="Código Practica"
            fieldsDisabled={false}
            autorizacion={true}
            idSolicitud={solicitudSeleccionada?.idSolicitud}
            laboratorio={idTipoSolicitud
              === TIPOS_AUTORIZACIONES.LABORATORIO}
            internacionDomiciliaria={idTipoSolicitud
              === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA}
            setCod={(val) => {
              setCodigoPractica(val)
              if (val?.nivelautorizacion === 0 && solicitudSeleccionada && idTipoSolicitud !== TIPOS_AUTORIZACIONES.OXIGENO)
                dispatch(startAlerta("La práctica que selecciono no necesita autorización por ser nivel 0", "warning", "Atencion"));
            }}
            esPresupuesto={presupuestoSeleccionado}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ width: "60%", margin: "auto" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "1.5rem 0",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={onClickAgregarHandler}
          >
            Agregar +
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
